module.exports = __webpack_public_path__ + "img/robot-home.90d11f5b.png";